import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.SET_DAYS](state, days) {
    state.retrospectiveDay = days
    storage.session.setItem(types.USER_DAYS, days)
  },
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.USER_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.USER_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.USER_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.USER_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.USER_FILTER_BY, filterBy)
  },
  [types.SET_EMAIL](state, data) {
    if (state.users !== undefined && state.users !== null) {
      if (state.users.items !== null) {
        for (let item of state.users.items) {
          if (item.contact === data.contact) {
            item.email = data.emailAddress
            break
          }
        }
      }
    }
  },
  [types.SET_FIRM](state, firm) {
    if (state.userFirms) {
      let found = state.userFirms.find((x) => parseInt(x.firm) === parseInt(firm))
      if (found) {
        found.checked = !found.checked
      }
    }
  },
  [types.SET_PRIMARY_FIRM](state, firm) {
    state.user.firm = parseInt(firm)
    state.userFirms.forEach((element) => {
      element.isPrimary = 0
      if (parseInt(element.firm) === parseInt(firm)) {
        element.isPrimary = 1
      }
    })
  },
  [types.SET_USER_FIRMS](state, data) {
    state.userFirms = data.data
    if (state.userFirms) {
      state.userFirms.forEach((userFirm) => {
        userFirm.user = data.user
        userFirm.checked = true
        if (userFirm.userFirm === null) {
          userFirm.checked = false
        }
      })
    }
  },
  [types.ADD_USER](state, data) {
    state.firmName = data.name
    state.user = {
      firm: data.firm,
      user: -1,
      contact: -1,
      contactType: 0,
      username: '',
      emailAddress: '',
      firstName: '',
      lastName: '',
      roles: '',
      password: '',
      timezone: 12,
      language: 1,
      laborRate: 0,
      receivesReport: false,
      receivesInvoice: false,
      isInactive: false
    }
  },
  [types.UPDATE_USER](state, data) {
    if (state.user !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.user.firm = parseInt(data.value)
          break
        case 'contact':
          state.user.contact = parseInt(data.value)
          break
        case 'contactType':
          state.user.contactType = parseInt(data.value)
          break
        case 'username':
          state.user.username = data.value
          break
        case 'password':
          state.user.password = data.value
          break
        case 'role':
          state.user.roles = data.value
          break
        case 'firstName':
          state.user.firstName = data.value
          break
        case 'lastName':
          state.user.lastName = data.value
          break
        case 'emailAddress':
          state.user.emailAddress = data.value
          break
        case 'language':
          state.user.language = parseInt(data.value)
          break
        case 'timezone':
          state.user.timezone = parseInt(data.value)
          break
        case 'laborRate':
          state.user.laborRate = parseFloat(data.value)
          break
        case 'isInactive':
          state.user.isInactive = data.value
          break
        case 'receivesReport':
          state.user.receivesReport = data.value
          break
        case 'receivesInvoice':
          state.user.receivesInvoice = data.value
          break
      }
    }
  },
  [types.SET_USER_CHECKED](state, data) {
    for (let user of state.users.items) {
      if (user.username === data.username) {
        user.isChecked = data.isChecked
      }
    }
    state.isUserChecked = false
    for (let user of state.users.items) {
      if (user.isChecked) {
        state.isUserChecked = true
        break
      }
    }
  },
  [types.SET_USERS](state, data) {
    state.users = []
    state.isUserChecked = false
    if (data !== undefined && data !== null) {
      if (data.items !== undefined && data.items !== null) {
        for (let item of data.items) {
          item.isChecked = false
        }
      }
      state.users = data
    }
  },
  [types.SET_ROLES](state, data) {
    state.roles = []
    for (let item of data) {
      state.roles.push({
        id: item.role,
        value: item.role,
        name: item.name
      })
    }
  },
  [types.SET_USER](state, data) {
    state.user = null
    if (data !== undefined && data !== null) {
      state.user = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users/mutations.js